<template>
  <qx-card-form title="事故信息" v-show="costType === 2009 && orgId">
    <ChooseAccident
      ref="chooseAccident"
      :customShow="true"
      :isRadio="true"
      :otherSearchData="{orgId, isVehicleFee: true}"
      @change="handleEditSub" />
    <span slot="titleLeft" class="titleLeftBtn primary cur" @click="showChoose">
      选择
    </span>
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import ChooseAccident from 'components/choose/accident';
export default {
  components: {
    ChooseAccident,
  },
  data () {
    return {
      chooseItem: {},
      costType: '',
      orgId: '',
      baseForm: {
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            disabled: true,
          },
          {
            label: '保险公司',
            value: 'insuranceCompany',
            type: 'input',
            disabled: true,
          },
          {
            label: '被保险人',
            value: 'insuranceUserName',
            type: 'input',
            disabled: true,
          },
          {
            label: '起保日期',
            value: 'insuranceStartDate',
            type: 'input',
            disabled: true,
          },
          {
            label: '终保日期',
            value: 'insuranceEndDate',
            type: 'input',
            disabled: true,
          },
          {
            label: '保单号',
            value: 'insuranceNumber',
            type: 'input',
            disabled: true,
          },
          {
            label: '出险日期',
            value: 'accidentTime',
            type: 'input',
            disabled: true,
          },
          {
            label: '报案日期',
            value: 'reportTime',
            type: 'input',
            disabled: true,
          },
          {
            label: '责任归属',
            value: 'responsibilityAttributionName',
            type: 'input',
            disabled: true,
          },
          {
            label: '是否本车车损',
            value: 'isVehicleDamageName',
            type: 'input',
            disabled: true,
          },
          {
            label: '是否对方车损',
            value: 'isOtherAccidentName',
            type: 'input',
            disabled: true,
          },
          {
            label: '是否物损',
            value: 'isGoodsDamageName',
            type: 'input',
            disabled: true,
          },
          {
            label: '是否道路损',
            value: 'isRoadDamageName',
            type: 'input',
            disabled: true,
          },
          {
            label: '人伤标志',
            value: 'isWoundingName',
            type: 'input',
            disabled: true,
          },
          {
            label: '维修服务商',
            value: 'repairServiceName',
            type: 'input',
            disabled: true,
          },
          {
            label: '维修金额',
            value: 'repairServiceAmt',
            type: 'input',
            disabled: true,
          },
          {
            label: '维修地点',
            value: 'repairServiceAddress',
            type: 'input',
            disabled: true,
          },
          {
            label: '联系方式',
            value: 'repairServiceTel',
            type: 'input',
            disabled: true,
          },
          {
            label: '是否完结',
            value: 'isRepairCompleteName',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    showChoose () {
      this.$refs.chooseAccident.show();
    },
    handleEditSub (item) {
      this.chooseItem = item;
      this.$refs.baseForm.setVal(item);
    },
    receiveData (tar, val) {
      this.orgId = val.orgId;
      if (val.costType) {
        this.costType = val.costType;
      }
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          accidentInfo: formData,
          ...this.chooseItem,
        };
      }
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        formData = {
          accidentInfo: JSON.stringify(formData),
        };
      }
      return formData;
    },
    async cacheData () {
      let res = await this.handleSubData(true);
      if (res) {
        res = {
          accidentInfo: res,
        };
      }
      return res;
    },
    async init (data = {}) {
      let detailList = data.costDetails || [];
      if (data.vehicleFeeFileDetails && typeof data.vehicleFeeFileDetails === 'string') {
        detailList = JSON.parse(data.vehicleFeeFileDetails);
      } else if (data.vehicleFeeFileDetails) {
        detailList = data.vehicleFeeFileDetails;
      }
      if (detailList && detailList[0]) {
        const item = detailList[detailList.length - 1];
        this.chooseItem = JSON.parse(JSON.stringify(item));
        this.$refs.baseForm.setVal('form', item);
      } else {
        this.$refs.baseForm.setVal('form', {});
      }
    },
  },
};
</script>

<style scoped lang="scss">
.titleLeftBtn{
  margin-left: 16px;
}
.tip{
  margin-left: 8px;
}
</style>
